/* Qpal UI helpers: quick add to cart, toast, cart badge, in-view video autoplay */
(function () {
  if (window.__qpalUI) return;
  window.__qpalUI = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(html) {
    var t = document.querySelector('.q-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'q-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-q-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-q-quick-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        if (btn) { btn.classList.add('is-added'); btn.textContent = '✓'; }
        toast('Added to cart <a href="' + root + 'cart">View cart</a>');
        refreshCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = label; } }, 1800);
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        toast((err && (err.description || err.message)) || 'Could not add — please try again');
      });
  });

  /* ---------- Wishlist (saved on this phone) ---------- */
  var WKEY = 'qpal-wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wlSet(list) { try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} wlPaint(); document.dispatchEvent(new CustomEvent('qpal:wishlist')); }
  function wlPaint() {
    var list = wlGet();
    document.querySelectorAll('[data-q-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-q-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.querySelector('[data-on]');
      if (lbl) lbl.textContent = on ? lbl.getAttribute('data-on') : lbl.getAttribute('data-off');
    });
    document.querySelectorAll('[data-q-wish-count]').forEach(function (el) { el.textContent = list.length; el.hidden = !list.length; });
  }
  window.qpalWishlist = { get: wlGet, set: wlSet, paint: wlPaint };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-q-wish'), list = wlGet(), i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.unshift(h); toast('Saved to wishlist ♥ <a href="' + root + 'pages/wishlist">View</a>'); }
    wlSet(list);
  });

  /* Autoplay muted videos only while visible (saves data on mobile) */
  function initVideos(scope) {
    var vids = (scope || document).querySelectorAll('video[data-q-autoplay], .qvr__media video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { v.muted = true; v.playsInline = true; io.observe(v); });
  }

  /* ---------- Stop image shimmer once loaded ---------- */
  function markLoaded(img) { var m = img.closest && img.closest('.q-card__media'); if (m) m.classList.add('is-loaded'); }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') markLoaded(e.target); }, true);
  document.addEventListener('error', function (e) { if (e.target && e.target.tagName === 'IMG') markLoaded(e.target); }, true);
  function markAllLoaded(scope) { (scope || document).querySelectorAll('.q-card__media img').forEach(function (img) { if (img.complete) markLoaded(img); }); }

  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('q-js');
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('q-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var sel = '.q-head, .q-card, .qcl__row > li, .qhc--grid .qhc__card, .qhc--banner .qhc__card, .qfc__card, .qvr__card, .qch__chip, .qft__grid > *, .qts__item, .qob, .qpb__i';
    (scope || document).querySelectorAll(sel).forEach(function (el) {
      if (el.classList.contains('q-reveal')) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0 && r.left < window.innerWidth) return; /* already on screen: no flash */
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--q-d', Math.min(sibs % 6, 5) * 0.07 + 's');
      el.classList.add('q-reveal');
      io.observe(el);
    });
  }

  function ready() {
    initVideos();
    wlPaint();
    initReveal();
    markAllLoaded();
    var active = document.querySelector('.qnt__tab.is-active');
    if (active && active.scrollIntoView) {
      var track = active.parentElement;
      track.scrollLeft = active.offsetLeft - (track.clientWidth - active.clientWidth) / 2;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); wlPaint(); initReveal(e.target); });
})();
